import { lazy } from "react";
import { BiMessageSquareDetail } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineContactSupport } from "react-icons/md";
import { RxDashboard } from "react-icons/rx";
import { TbFileUpload } from "react-icons/tb";
import { PiUsers } from "react-icons/pi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { RouteConf, UserRole } from "types";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Messages = lazy(() => import("../pages/Messages"));
const Submissions = lazy(() => import("../pages/Submissions"));
const Settings = lazy(() => import("../pages/Settings"));
const Assistance = lazy(() => import("../pages/Assistance"));
const UsersManagement = lazy(() => import("../pages/UsersManagement"));
const Explanations = lazy(() => import("../pages/Explanations"));
const routesSetup: RouteConf[] = [
  {
    path: "/dashboard",
    component: Dashboard,
    access: { roles: Object.values(UserRole) },
    menu: {
      title: "Tableau de bord",
      icon: { icon: RxDashboard, size: 22 },
    },
  },
  {
    path: "/users-management",
    component: UsersManagement,
    access: { roles: [UserRole.admin, UserRole.adminSchool] },
    menu: {
      title: "Utilisateurs",
      icon: { icon: PiUsers, size: 22 },
    },
  },
  {
    path: "/messages",
    component: Messages,
    access: { exclude: [UserRole.parent, UserRole.admin] },
    menu: {
      title: "Messages",
      icon: { icon: BiMessageSquareDetail, size: 23 },
      hasUnreadMsgBadge: true,
    },
  },
  {
    path: "/submissions",
    component: Submissions,
    access: { exclude: [UserRole.parent] },
    menu: {
      title: "Soumissions",
      icon: { icon: TbFileUpload, size: 25 },
    },
  },
  {
    path: "/settings",
    component: Settings,
    access: { roles: Object.values(UserRole) },
    menu: {
      title: "Paramètres",
      icon: { icon: IoSettingsOutline, size: 25 },
    },
  },
  {
    path: "/assistance",
    component: Assistance,
    access: { roles: Object.values(UserRole) },
    menu: {
      title: "Support",
      icon: { icon: MdOutlineContactSupport, size: 25 },
      hasUnreadMsgBadge: true,
    },
  },
  {
    path: "/explanations",
    component: Explanations,
    access: { exclude: [UserRole.parent] },
    menu: {
      title: "Explications",
      icon: { icon: FaChalkboardTeacher, size: 22 },
    },
  },
];

const routes = [...routesSetup];
export default routes;
